export default "__VITE_ASSET__vRzniz6___"